@if (order$ | async) {
  <fin-corporate-widget [image$]="image$">
    <div class="flex flex--space-between column-wrapper">
      <div>
        <h4 class="font-heading-4">
          {{ 'CORPORATE.corporatePortal.widgets.yourNextTrip.title' | finLocalization }}
        </h4>
        <div class="font-body-2">{{ subtitle$ | async }}</div>
      </div>
      <div>
        @if (checkedIn$ | async) {
          <fcom-tag [theme]="TagTheme.SUCCESS">
            <fcom-icon class="ms-xxsmall-r icon-small" [name]="SvgLibraryIcon.CHECKMARK"></fcom-icon>
            <span>{{ 'MMB.checkIn.confirmation.status.checkInStatus.checkedIn' | finLocalization }}</span>
          </fcom-tag>
        }
      </div>
    </div>

    @if (locations$ | async; as locations) {
      <div class="flex flex--space-between column-wrapper ms-medium-t">
        <div>
          <div class="font-body-1 bold-type">{{ locations[0].cityName }} - {{ locations[1].cityName }}</div>
          @if (nextBound$ | async; as nextBound) {
            <div class="font-body-1 medium-type">
              {{ nextBound.departure.dateTime | finDateFormat: 'FULL' }}
              <fcom-icon class="ms-xxsmall-x icon-small" [name]="SvgLibraryIcon.DEPARTURE"></fcom-icon>
              {{ nextBound.departure.dateTime | finTime }}
            </div>
          }
        </div>
        <div class="flex">
          <div>
            <div class="font-body-2 medium-type">
              {{ 'CORPORATE.corporatePortal.widgets.yourNextTrip.bookingReference' | finLocalization }}
            </div>
            <div class="font-body-1 bold-type">{{ (trip$ | async).bookingReference }}</div>
          </div>
          @if (trip$ | async; as trip) {
            <div class="ms-small-l">
              <fcom-icon-button
                [aria]="{
                  label: 'CORPORATE.corporatePortal.widgets.yourNextTrip.copyToClipBoardAria' | finLocalization,
                }"
                [icon]="{ name: SvgLibraryIcon.COPY }"
                [theme]="IconButtonTheme.LIGHT_TERTIARY_GHOST"
                (clickBtn)="copyToClipboard(trip.bookingReference)"
              >
              </fcom-icon-button>
            </div>
          }
        </div>
      </div>
    }

    @if (trip$ | async; as trip) {
      <div class="ms-medium-t">
        @if ((upgradeAvailable$ | async) === true) {
          <fcom-notification
            [iconName]="SvgLibraryIcon.UPGRADE"
            [title]="'CORPORATE.corporatePortal.widgets.yourNextTrip.upgradeTitle' | finLocalization"
            [linkText]="'CORPORATE.corporatePortal.widgets.yourNextTrip.upgradeLink' | finLocalization"
            [buttonStyle]="NotificationButtonStyle.LINK"
            (linkClick)="goToUpgrade()"
          >
            {{ 'CORPORATE.corporatePortal.widgets.yourNextTrip.upgradeDescription' | finLocalization }}
          </fcom-notification>
        } @else if ((upgradeAvailable$ | async) === false) {
          <fcom-notification
            [iconName]="SvgLibraryIcon.EXTRA_CHECK_IN_BAGGAGE"
            [title]="'CORPORATE.corporatePortal.widgets.yourNextTrip.travelExtrasTitle' | finLocalization"
            [linkText]="'CORPORATE.corporatePortal.widgets.yourNextTrip.travelExtrasLink' | finLocalization"
            [buttonStyle]="NotificationButtonStyle.LINK"
            (linkClick)="goToTravelExtras(trip)"
          >
            {{ 'CORPORATE.corporatePortal.widgets.yourNextTrip.travelExtrasDescription' | finLocalization }}
          </fcom-notification>
        } @else {
          <div class="flex flex--center ps-xlarge-y nordic-blue-50-bg rounded-large">
            <fcom-loader [loaderType]="LoaderTheme.INLINE_TEXT"></fcom-loader>
          </div>
        }
      </div>
    }

    @if (trip$ | async; as trip) {
      <div class="flex flex--end ms-medium-t button-container">
        <fcom-button
          [text]="'CORPORATE.corporatePortal.widgets.yourNextTrip.manageBooking' | finLocalization"
          [mode]="ButtonMode.FILL_MOBILE"
          [theme]="manageBookingButtonTheme$ | async"
          (clickBtn)="manageBooking(trip)"
        ></fcom-button>
        @if (showCheckinButton$ | async) {
          <fcom-button
            class="ms-small-l"
            [text]="'CORPORATE.corporatePortal.widgets.yourNextTrip.checkInButton' | finLocalization"
            [mode]="ButtonMode.FILL_MOBILE"
            (clickBtn)="goToCheckin()"
          >
          </fcom-button>
        }
        @if (checkedIn$ | async) {
          <fcom-button
            class="ms-small-l"
            [text]="'CORPORATE.corporatePortal.widgets.yourNextTrip.showBoardingPass' | finLocalization"
            [mode]="ButtonMode.FILL_MOBILE"
            (clickBtn)="goToBoardingPass()"
          >
          </fcom-button>
        }
      </div>
    }
  </fin-corporate-widget>
} @else {
  <fcom-loader></fcom-loader>
}
